//热点类型事件集合
const hostspotMaps = [
  {
    value: 1,
    key: 'scene',
    fn: 'onSceneHotspotClick',
  },
  {
    value: 2,
    key: 'link',
    fn: 'onLinkHotspotClick',
  },
  {
    value: 3,
    key: 'phone',
    fn: 'onPhoneHotspotClick',
  },
  {
    value: 4,
    key: 'img',
    fn: 'onImgHotspotClick',
  },
  {
    value: 5,
    key: 'imgText',
    fn: 'onImgTextHotspotClick',
  },
  {
    value: 6,
    key: 'music',
    fn: 'onMusicHotspotClick',
  },
  {
    value: 7,
    key: 'rings',
    fn: 'onRingsHotspotClick',
  },
  {
    value: 8,
    key: 'video',
    fn: 'onVideoHotspotClick',
  },
  {
    value: 9,
    key: 'iframe',
    fn: 'onIframeHotspotClick',
  },
  {
    value: 10,
    key: 'article',
    fn: 'onArticleHotspotClick',
  },
  {
    value: 11,
    key: 'model',
    fn: 'on3DHotspotClick',
  },
  {
    value: 14,
    key: 'richtext',
    fn: 'onRichtexthotspotClick',
  },
  {
    value: 15,
    key: 'richtext',
    fn: 'onNavigationhotspotClick',
  },
];
const actionBtntMaps = [
  {
    value: 1,
    key: 'selectScene',
    fn: 'onSceneBtnClick',
  },
];
function initXmlData(data) {
  if (data) {
    if (typeof data == 'object') {
      data = eval(data);
    }else{
      data = JSON.parse(eval(data));
    }
  }
  return data;
}

//xml调用的全局事件
export default (krpano, _this) => {
  // window.introduce=()=>{
  //   //xml触发详情事件
  //   if(!curPano||!curPano.showPanoinfo) return;
  //   curPano.showPanoinfo();
  // }
  // window.share=()=>{
  //   //xml触发分享事件
  //   if(!curPano||!curPano.showPanoinfo) return;
  //   curPano.showPanoQrcode();
  // }
  //点击开启vr模式时
  window.handleEnterVr = function() {
    _this.onEnterVrClick();
  };

  //点击关闭vr模式时
  window.handleExitVr = function() {
    _this.onExitVrClick();
  };

  //热点点击时
  window.handleHospotClick = function(type, data) {
    switch (Number(type)) {
      case 11:
        _this.on3DHotspotClick(data);
        break;
      default:
        throw '未定义热点类型！';
        break;
    }
  };
  //热点点击时
  window.handleHotspotClick = function(type, data) {
    const hotspot = hostspotMaps.find(el => el.value === Number(type));
    if (!hotspot) {
      throw '未定义热点类型！';
    }
    data = initXmlData(data);
    if (!data || JSON.stringify(data) == '[]' || JSON.stringify(data) == '{}') return;
    _this[hotspot.fn](data);
  };

  //热点按钮点击事件
  window.handleActionBtnClick = function(type, data) {
    const item = actionBtntMaps.find(el => el.key === type);
    if (!item) {
      throw '未定义按钮类型！';
    }
    data = initXmlData(data);
    _this[item.fn](data);
  };

  //切换场景方法
  window.changeSceneByName = function(name){
    _this.changeSceneByName(name);
    _this.updateSceneListByName(name);
  }


  //UI 点击事件
  //全屏
  window.handleFullScreen = function(data) {
    _this.krpano.call('switch(fullscreen);')
  };
  //VR模式
  window.handleVR = function(data) {
    _this.krpano.call('gyro_start();webvr.enterVR();')
  };
  //背景音乐
  window.handleMusicBg = function(data) {
    _this.krpano.call("bgSound_change()")
  };
  //解说音乐
  window.handleMusicExplain = function(data) {
    _this.krpano.call("commentarySound_change()")
  };
  //自动巡游
  window.autoCruise = function(data){
    const angle_view = data.angle_view == 1 ? true : false;
    const switchScene = data.switchScene == 1 ? true : false;
    _this.krpano.call('timer.start(autotour,' + data.time + ',' + data.speed + ',' + angle_view + ',' + switchScene + ');');
    if (data.open == 1) {
      _this.krpano.call("delayedcall(autoscene,15,nextscene);set(autorotate.enabled,true)");
      _this.setBtnBg('cruise_img',true);
    }else{
      _this.krpano.call("set(autorotate.enabled,false);stopdelayedcall(autoscene);");
      _this.setBtnBg('cruise_img',false);
    }
  }
  //按钮切换巡游
  window.handleCruise = function(data) {
    if (_this.krpano.get('autorotate.enabled') == true) {
      _this.krpano.call("set(autorotate.enabled,false);stopdelayedcall(autoscene);");
      _this.setBtnBg('cruise_img',false);
    }else{
      _this.krpano.call("delayedcall(autoscene,15,nextscene);set(autorotate.enabled,true)");
      _this.setBtnBg('cruise_img',true);
    }
  };
  //点赞
  window.handleGood = function(data){
    _this.setBtnBg('fabulous_img',false);
    var $fabulousText = $('#fabulous_text');
    if (!$fabulousText) return;
    $fabulousText.html(Number($fabulousText.html()) + data);
  }
  //沙盘
  window.handleSandTable = function(data) {
    _this.krpano.call("open_radar();");
  };
  //陀螺仪
  window.autoGyro = function(data) {
    if (data.auto_open == 1) {
      _this.krpano.call("switch(plugin[skin_gyro].enabled); if(plugin[skin_gyro].enabled, skin_showmap(false));");
      _this.setBtnBg('gyro_img',true);
    }else{
      _this.setBtnBg('gyro_img',false);
    }
  };
  window.handleGyro = function(data){
    _this.krpano.call("switch(plugin[skin_gyro].enabled); if(plugin[skin_gyro].enabled, skin_showmap(false));");
    if (_this.krpano.get("plugin[skin_gyro].enabled")){
      _this.setBtnBg('gyro_img',true);
    }else{
      _this.setBtnBg('gyro_img',false);
    }
  }
  //自动巡游结束时
  window.handleCruiseEnd = function(data) {
    data = JSON.parse(data);
    _this.onSceneCruiseEnd(data);
  };
  //自动巡游结束时
  window.handlePanoStart = function(data) {
    // data = JSON.parse(data);
    // console.log(data);
    // _this.onPanoStart(data);
  };

  //krpano events 事件

  //旧场景关闭时
  window.handleRemovePano = function(e) {
    _this.onRemovePano();
  };

  //切换到新场景时
  window.handleNewScene = function(data) {
    // data = initXmlData(data);
    _this.onNewScene(data);
  };

  //加载错误时
  window.handleLoadError = function(e) {
    _this.onLoadError();
  };

  //getXmlScene  获取音乐
  window.getXmlScene = function(music1, music2, loop1, loop2, play1, play2) {
    // _this.initMusic(music1, music2, loop1, loop2, play1, play2);
  };

  //点击分享按钮时
  window.handleShareClick = function(e) {
    _this.showQrcode();
  };

  //点击简介按钮时
  window.handleIntroduceClick = function(e) {
    _this.showPanoinfo();
  };

  // //点击背景音乐热点时
  // window.handleMusicBgClick = function() {
  //   // _this.showPanoinfo();
  //   console.log('toggle bg');
  //   _this.toggleBgMusic();
  // };

  // //点击解说音乐热点时
  // window.handleMucicExplainClick = function() {
  //   // _this.showPanoinfo();
  //   console.log('toggle explain');
  //   _this.toggleExplainMusic();
  // };

  //点击背景音乐热点时
  window.musicBgPlayOrPause = function() {
    // _this.showPanoinfo();
    _this.onUserChangeBgmusic();
  };

  //点击解说音乐热点时
  window.musicExplainPlayOrPause = function() {
    // _this.showPanoinfo();
    _this.onUserChangeExplainmusic();
  };

  //xml嵌入视频播放时
  window.handlePanoVideoPlay = function() {
    //暂停所有音乐
    _this.pauseAllMusic();
  };

  //xml嵌入视频暂停时
  window.handlePanoVideoPause = function() {};

  //xml错误时
  window.handleXmlError = function() {
    console.log('xmlerror');
  };

  //加载失败时
  window.handleLoadError = function() {
    console.log('loaderror');
  };

  //加载失败时
  window.openUrl = function(url) {
    window.open(url)
  };

  //创建swiper 抛出放大缩小重置函数
  window.newSwiper = function(){
    mySwiper = new Swiper('.pano-swiper-container', {
      zoom:{
        maxRatio:3,
        minRatio:1
      },
      preloadImages: true,
      updateOnImagesReady : true,
      loop:true,
      navigation: {
        nextEl: '.swiper-nav.next',
        prevEl: '.swiper-nav.prev'
      },
      pagination: {
        el: '.pano-swiper-pagination',
        type:'fraction'
      },
      on: {
        slideChangeTransitionStart: function(){
          var $currentSlide = $('.swiper-slide');
          $currentSlide.removeClass('swiper-slide-zoomed');
        },
      }
    })
  }
  window.handleZoomIn = function(){
    var currentScale = Number(mySwiper.zoom.scale) + 1;
    var $currentImgSlide = $('.swiper-slide-active');
    var $currentZoomContainer = $('.swiper-slide-active .swiper-zoom-container');
    var $currentImg = $('.swiper-slide-active img');
    if (currentScale <= 5) {
      mySwiper.zoom.in();
      $currentImgSlide.addClass('swiper-slide-zoomed');
      $currentZoomContainer.css({'transition-duration': '300ms', 'transform': 'translate3d(0px, 0px, 0px)'});
      mySwiper.zoom.scale = currentScale;
      $currentImg.css({'transition-duration': '300ms', 'transform': 'translate3d(0px, 0px, 0px) scale('+currentScale+')'})
    }
  }
  window.handleZoomOut = function(){
    var currentScale = Number(mySwiper.zoom.scale) - 1;
    var $currentImgSlide = $('.swiper-slide-active');
    var $currentZoomContainer = $('.swiper-slide-active .swiper-zoom-container');
    var $currentImg = $('.swiper-slide-active img');
    if (currentScale >= 1) {
      $currentImgSlide.addClass('swiper-slide-zoomed');
      $currentZoomContainer.css({'transition-duration': '300ms', 'transform': 'translate3d(0px, 0px, 0px)'});
      mySwiper.zoom.scale = currentScale;
      $currentImg.css({'transition-duration': '300ms', 'transform': 'translate3d(0px, 0px, 0px) scale('+currentScale+')'})
    }
  }
  window.handleZoomReset = function(){
    var $currentImgSlide = $('.swiper-slide-active');
    var $currentImg = $('.swiper-slide-active img');
    var $currentZoomContainer = $('.swiper-slide-active .swiper-zoom-container');
    if ($currentImg.attr("style") && $currentImg.attr("style").indexOf("transform") != -1) {
      mySwiper.zoom.scale = 1;
      $currentImgSlide.removeClass('swiper-slide-zoomed');
      $currentZoomContainer.css({'transition-duration': '300ms', 'transform': 'translate3d(0px, 0px, 0px)'});
      $currentImg.css({'transition-duration': '300ms', 'transform': 'translate3d(0px, 0px, 0px) scale(1)'});
    }
  }

  $(document).click(function(e){
    var _con = $('.scene-list');   // 设置目标区域
    var _btn = $('#selectScene');
    if (_con.css('display') !== 'none') {
      if(!_con.is(e.target) && !_btn.is(e.target) && _con.has(e.target).length === 0 && _btn.has(e.target).length === 0){
        _this.hideSceneList()
      }
    }

    var _con1 = $('.details-list');   // 设置目标区域
    var _btn1 = $('#details-btn');
    if (_con1.css('display') !== 'none') {
      if(!_con1.is(e.target) && !_btn1.is(e.target) && _con1.has(e.target).length === 0 && _btn1.has(e.target).length === 0){
        _this.hideDetailsList()
      }
    }
  });
};
